/**
 * Shared utility functions for API services
 */
export class ApiUtils {
  /**
   * Get nested value from object using dot notation path
   * @param obj - Source object
   * @param path - Dot notation path (e.g., 'data.items')
   * @returns Nested value or undefined
   */
  static getNestedValue(obj: unknown, path: string): unknown {
    return path.split('.').reduce(
      (current: unknown, key: string) => (current as Record<string, unknown>)?.[key],
      obj
    );
  }

  /**
   * Check if code is running in browser environment
   */
  static isBrowser(): boolean {
    return typeof window !== 'undefined';
  }

  /**
   * Safe localStorage access
   */
  static getFromStorage(key: string): string | null {
    return this.isBrowser() ? localStorage.getItem(key) : null;
  }

  /**
   * Safe localStorage write
   */
  static setToStorage(key: string, value: string): void {
    if (this.isBrowser()) {
      localStorage.setItem(key, value);
    }
  }
}